import { Component, OnInit, ViewChild } from '@angular/core';
import { EmailEditorComponent } from 'angular-email-editor';

@Component({
  selector: 'email-template-designer',
  styleUrls: ['./email-template-designer.component.scss'],
  templateUrl: 'email-template-designer.component.html',
})
export class EmailTemplateDesignerComponent implements OnInit {
  ngOnInit(): void {}

  title = 'angular-email-editor';

  @ViewChild(EmailEditorComponent)
  private emailEditor: EmailEditorComponent;

  editorLoaded() {
    // load the design json here
    // this.emailEditor.editor.loadDesign({});
    /*
    this.emailEditor.editor.init({
      id: 'editor-1',
      mergeTags: {
        first_name: {
          name: "First Name",
          value: "{{first_name}}",
          sample: "John"
        },
        last_name: {
          name: "Last Name",
          value: "{{last_name}}",
          sample: "Doe"
        }
      }
    });
    
     */
  }

  exportHtml() {
    this.emailEditor.editor.exportHtml((data) => console.log('exportHtml', data));
  }
}
